import { useState } from "react";
import { Chapter, Reveal } from "@/components/aklive/motion";
import { PlaceholderBlock } from "@/components/aklive/PlaceholderBlock";

const STAGES = [
  { title: "Understand", sentence: "We start with the business before the brief." },
  { title: "Define", sentence: "We agree what the work needs to achieve." },
  { title: "Build", sentence: "We design, write and build with intent." },
  { title: "Refine", sentence: "We sharpen every detail until it holds up." },
];

export const Process = () => {
  const [active, setActive] = useState(0);

  return (
    <section className="py-24 md:py-40" data-testid="process-section">
      <div className="container-ak">
        <Chapter index="04" label="Process" />

        <Reveal className="hidden border-y border-line md:grid md:grid-cols-4 md:divide-x md:divide-line">
          {STAGES.map((s, i) => (
            <button
              key={s.title}
              type="button"
              data-testid={`process-stage-${i}`}
              onMouseEnter={() => setActive(i)}
              onFocus={() => setActive(i)}
              onClick={() => setActive(i)}
              className="p-8 text-left lg:p-10"
            >
              <span
                className={`font-mono text-xs tracking-[0.2em] transition-colors duration-300 ${
                  active === i ? "text-ember" : "text-ink2"
                }`}
              >
                0{i + 1}
              </span>
              <span className="mt-4 block font-display text-2xl font-bold tracking-tight text-ink lg:text-3xl">
                {s.title}
              </span>
              <span
                className={`mt-4 block min-h-[3.5rem] max-w-[240px] text-sm leading-relaxed text-ink2 transition-[opacity,transform] duration-300 ${
                  active === i ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0"
                }`}
                aria-hidden={active !== i}
              >
                {s.sentence}
              </span>
            </button>
          ))}
        </Reveal>

        <div className="border-t border-line md:hidden">
          {STAGES.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.08}>
              <div className="border-b border-line py-7" data-testid={`process-stage-mobile-${i}`}>
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-[10px] tracking-[0.2em] text-ember">0{i + 1}</span>
                  <h3 className="font-display text-2xl font-bold tracking-tight text-ink">{s.title}</h3>
                </div>
                <p className="mt-2 pl-7 text-sm leading-relaxed text-ink2">{s.sentence}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-12 gap-4 md:mt-24 md:gap-8">
          <Reveal className="col-span-7 md:col-span-5">
            <PlaceholderBlock label="[WIREFRAMES — 4:3]" ratio="4 / 3" />
          </Reveal>
          <Reveal delay={0.1} className="col-span-5 mt-10 md:col-span-3 md:mt-16">
            <PlaceholderBlock label="[MOODBOARD — 1:1]" ratio="1 / 1" />
          </Reveal>
          <Reveal delay={0.2} className="col-span-8 col-start-3 md:col-span-4 md:col-start-9 md:mt-8">
            <PlaceholderBlock label="[TYPE EXPLORATION — 3:2]" ratio="3 / 2" />
          </Reveal>
        </div>
      </div>
    </section>
  );
};
